var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_151_101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28C12.0677 28 10.2539 27.6354 8.55859 26.9062C6.86328 26.1589 5.38216 25.1517 4.11523 23.8848C2.84831 22.6178 1.84115 21.1367 1.09375 19.4414C0.364583 17.7461 0 15.9323 0 14C0 12.0677 0.364583 10.2539 1.09375 8.55859C1.84115 6.86328 2.84831 5.38216 4.11523 4.11523C5.38216 2.84831 6.86328 1.84115 8.55859 1.09375C10.2539 0.364584 12.0677 0 14 0C15.9323 0 17.7461 0.364584 19.4414 1.09375C21.1367 1.84115 22.6178 2.84831 23.8848 4.11523C25.1517 5.38216 26.1589 6.86328 26.9062 8.55859C27.6354 10.2539 28 12.0677 28 14C28 15.9323 27.6354 17.7461 26.9062 19.4414C26.1589 21.1367 25.1517 22.6178 23.8848 23.8848C22.6178 25.1517 21.1367 26.1589 19.4414 26.9062C17.7461 27.6354 15.9323 28 14 28ZM14 1.75C12.3047 1.75 10.7188 2.06901 9.24219 2.70703C7.7474 3.36328 6.44857 4.24284 5.3457 5.3457C4.24284 6.44857 3.36328 7.7474 2.70703 9.24219C2.06901 10.7188 1.75 12.3047 1.75 14C1.75 15.6953 2.06901 17.2812 2.70703 18.7578C3.36328 20.2526 4.24284 21.5514 5.3457 22.6543C6.44857 23.7572 7.7474 24.6367 9.24219 25.293C10.7188 25.931 12.3047 26.25 14 26.25C15.6953 26.25 17.2812 25.931 18.7578 25.293C20.2526 24.6367 21.5514 23.7572 22.6543 22.6543C23.7572 21.5514 24.6367 20.2526 25.293 18.7578C25.931 17.2812 26.25 15.6953 26.25 14C26.25 12.3047 25.931 10.7188 25.293 9.24219C24.6367 7.7474 23.7572 6.44857 22.6543 5.3457C21.5514 4.24284 20.2526 3.36328 18.7578 2.70703C17.2812 2.06901 15.6953 1.75 14 1.75ZM20.125 14.875H7.875C7.63802 14.875 7.43294 14.7884 7.25977 14.6152C7.08659 14.4421 7 14.237 7 14C7 13.763 7.08659 13.5579 7.25977 13.3848C7.43294 13.2116 7.63802 13.125 7.875 13.125H20.125C20.362 13.125 20.5671 13.2116 20.7402 13.3848C20.9134 13.5579 21 13.763 21 14C21 14.237 20.9134 14.4421 20.7402 14.6152C20.5671 14.7884 20.362 14.875 20.125 14.875Z",
    fill: "url(#paint0_linear_151_101)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_151_101",
    x1: -3.07514,
    y1: 14.0809,
    x2: 28,
    y2: 10.6821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#164EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF6AE2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_151_101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minus-icon.6e8291038c3846980ab07bda65168ea3.svg";
export { ForwardRef as ReactComponent };